import { AlertColor, Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useState } from "react";

import ButtonGeneric from "../../components/ButtonGeneric";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { api } from "../../services/api";
import { ValidateCustomerModalStyled } from "./styles";

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setCurrentCustomer: any;
    myParam: string;
    handleCloseValidateCustomerModal: () => void;
    openValidateCustomerModal: boolean;
}

function ValidateCustomerModal({
    setCurrentCustomer,
    handleCloseValidateCustomerModal,
    openValidateCustomerModal,
    myParam,
}: Props) {
    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] = useState<
        AlertColor | undefined
    >();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    function installImplementation() {
        setIsLoadingButton(true);
        api.put(`/customers/validation/${myParam}`, {})
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    handleCloseValidateCustomerModal();
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .then(() => {
                api.get(`customers/${myParam}`)
                    .then((response) => {
                        setCurrentCustomer(response.data.response);
                    })
                    .catch((error) => {
                        setOpenToast(true);
                        setToastRequisitionResult("error");
                        setTextToast(error.response.data.message);
                    });
            })
            .catch((error) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(error.response.data.message);
                setIsLoadingButton(false);
            });
    }

    return (
        <Modal
            open={openValidateCustomerModal}
            onClose={handleCloseValidateCustomerModal}
        >
            <ValidateCustomerModalStyled>
                <Box>
                    <p className="topModalText">
                        Você realmente deseja validar o cliente? Essa ação é
                        irreversível!
                    </p>
                    <form name="editFormModal">
                        <div className="buttonsContainer">
                            <ButtonGeneric
                                onclick={() => {
                                    handleCloseValidateCustomerModal();
                                }}
                                buttonColor="var(--cancel)"
                                text="CANCELAR"
                            />
                            <PreloadButton
                                colorText="white"
                                background="var(--confirm)"
                                loading={isLoadingButton}
                                text="Confirmar"
                                type="submit"
                                onClick={() => {
                                    installImplementation();
                                }}
                                sx={{ minWidth: "140px" }}
                            />
                        </div>
                    </form>
                    <Toast
                        open={openToast}
                        onClose={() => handleCloseToast()}
                        severity={toastRequisitionResult}
                        text={textToast}
                    />
                </Box>
            </ValidateCustomerModalStyled>
        </Modal>
    );
}
export default ValidateCustomerModal;
